import React from 'react';
import { Grid } from '@mui/material';
import { Translate } from 'react-localize-redux';
import { ButtonContinue } from '../mini_components';

export interface AllergyFirstStepProps {
    /** Open the add-allergy form (active-principle autocomplete; carries its own Cancel). */
    onAddNew: () => void;
    /** Record "reviewed, no known allergies" (the NAMC sentinel / green state). */
    onNoKnown: () => void;
}

/**
 * SHER-263 P6 — allergy form first step.
 *
 * The allergy SmartField used to open on a confusing "Allergies: Yes / No"
 * dropdown (it shared the generic INITIAL_SELECT selector with diagnosis /
 * treatment / background fields). Pedro asked for explicit actions instead, so
 * for the allergy field SmartField renders THIS two-button step rather than the
 * Yes/No <Select>:
 *   - "Add new allergy"            → opens the active-principle autocomplete form.
 *   - "Mark as no known allergies" → records the green "no known" state.
 *
 * Presentational only: the host (SmartField) owns the state transitions.
 */
function AllergyFirstStep({ onAddNew, onNoKnown }: AllergyFirstStepProps) {
    return (
        <Grid container spacing={1} style={{ paddingTop: '1rem' }} data-testid="allergy-first-step">
            <Grid item>
                <ButtonContinue data-testid="allergy-add-new" onClick={onAddNew}>
                    <Translate id="clinicalSummary.allergy.addNew" />
                </ButtonContinue>
            </Grid>
            <Grid item>
                <ButtonContinue data-testid="allergy-mark-no-known" onClick={onNoKnown} color="green">
                    <Translate id="clinicalSummary.allergy.update.noKnownToggle" />
                </ButtonContinue>
            </Grid>
        </Grid>
    );
}

export default AllergyFirstStep;
